module.exports = __webpack_public_path__ + "static/media/redantpdx_small.cc25c2cd.png";